import React, { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import Peer from "simple-peer";

import UserJoined from "../sounds/userjoined.mp3";
import UserLeft from "../sounds/userleaved.mp3";

import Loader from "./Loader";
import { ScreenAcc } from "./Modals/ScreenAcc";
import { Badge } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faPaperPlane,
  faTimes,
  faCloudUploadAlt,
  faMicrophone,
  faMicrophoneSlash,
  faVideo,
  faVideoSlash,
  faRecordVinyl,
  faPhone,
  // faStopCircle, faCommentDots,
  faUsers,
  faArrowUp,
  faEllipsisH,
  faInfo,
} from "@fortawesome/free-solid-svg-icons";
import Draggable from "react-draggable";
import styled from "styled-components";
import { auth, db, storage } from "../config/fire";
import { useHistory } from "react-router-dom";
import {
  Tooltip,
  Progress,
  Avatar,
  message,
  Button,
  Layout,
  Menu,
  Dropdown,
  Modal,
} from "antd";

///////icons & images  ////////
import {
  AudioMutedOutlined,
  //  AudioOutlined,
  UserOutlined,
} from "@ant-design/icons";
import VideoOff from "../images/videoOff.svg";
import {
  VedioContainer,
  CallControlWrapper,
  UserName,
  MessageBox,
  ScreenSection,
  MessageButtonContainer,
} from "./styles";
import { ScreenReq } from "./Modals/ScreenReq";

const { Sider, Content } = Layout;

Peer.config = {
  iceServers: [
    {
      urls: "stun:stun.l.google.com:19302",
    },
    {
      urls: "stun:stun1.l.google.com:19302",
    },
  ],
  sdpSemantics: "unified-plan",
};

export const Container = styled(Layout)`
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: #fff;
  position: relative;

  @media only screen and (max-width: 728px) {
    height: 100%;
  }
`;

export const VideoControl = styled.div`
  display: flex;
  height: 100%;
  width: 80%;
  overflow: hidden;
  overflow-y: auto;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  .anticon svg {
    display: inline-block;
    width: 30px;
    height: 30px;
  }
  img {
    height: 30px;
    width: 30px;
  }
  .activeUsers {
    display: flex;
    flex-direction: column;
    height: 30% !important;
    .userName {
      display: flex;
      flex-direction: row;
    }
    .anticon svg {
      border: 2px solid #000;
      width: 35px;
      border-radius: 25px;
      margin-right: 10px;
      height: 35px;
      padding: 6px;
    }
    p {
      text-transform: uppercase;
      font-size: 16px;
      font-weight: 500;
      margin-top: 5px;
    }
  }
`;

export const OptionContainer = styled.div`
  width: 50%;
  position: absolute;
  bottom: 25px;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: rgb(50 50 105 / 15%) 0px 2px 5px 0px,
    rgb(0 0 0 / 5%) 0px 1px 1px 0px;
  border-radius: 10px;
  .anticon svg {
    display: inline-block;
    width: 30px;
    height: 30px;
  }
  img {
    height: 25px;
    width: 25px;
  }
  .iconContainer {
    background-image: linear-gradient(to right, #41d4b3, #067d68);
    color: white;
    border-radius: 50%;
    padding: 5px;
    font-size: 14px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 17px rgb(0 0 0 / 35%);
    }
  }
`;
const StyledVideo = styled.video`
  width: 90%;
  border-radius: 5px;
`;

const StyledImage = styled.img`
  width: 90%;
  border-radius: 5px;
`;

const Option = styled.div`
  cursor: pointer;
`;

const AllUsersVideo = styled.div`
  position: relative;
  padding-top: 20px;
  // flex-basis: 23%;
  margin: 5px;
`;

const Sidebar = styled(Sider)`
  max-width: 25% !important;
  min-width: 25% !important;
  width: 25% !important;
  box-shadow: rgb(50 50 105 / 15%) 0px 2px 5px 0px,
    rgb(0 0 0 / 5%) 0px 1px 1px 0px;
  background: #ffffff;
  padding: 15px;
  .title {
    font-size: 15px;
    padding-top: 5px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
  }
  .close-container {
    position: absolute;
    right: 15px;
    top: 15px;
    .fa-icon {
      color: #505050ad;
      font-size: 15px;
      cursor: pointer;
    }
  }
  .participant-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0px;
    p {
      margin: 0 !important;
      font-family: Roboto;
      font-size: 15px;
      font-weight: 500;
      color: rgba(35, 35, 35, 0.78);
    }
    span {
      padding-left: 25px;
      color: rgb(10 131 109);
    }
  }
`;

const MenuDetail = styled.p`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  color: rgb(35 35 35 / 93%);
  margin: 0 !important;
  cursor: pointer;
`;

const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  p {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    color: rgb(35 35 35 / 93%);
    // margin: 0 !important;
  }
  .modal-icon-div {
    background-image: linear-gradient(to right, #41d4b3, #067d68);
    color: white;
    border-radius: 50%;
    padding: 5px;
    font-size: 16px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }
`;

const UserInitLogoDiv = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: white;
    margin: 0 !important;
    font-size: 40px;
    font-weight: 500;
    cursor: pointer;
  }
`;

const DraggableDiv = styled.div`
  right: 10px;
  bottom: 15%;
  z-index: 4;
  position: absolute;
  width: 25%;
  .fa-icon {
    position: absolute;
    color: #ffffff66;
    right: 37px;
    top: 10px;
    font-size: 15px;
  }
`;

const Video = (props) => {
  const UserInitLogoDiv = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: black;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      color: white;
      margin: 0 !important;
      font-size: 40px;
      font-weight: 500;
      cursor: pointer;
    }
  `;
  const ref = useRef();
  const [muted, setmuted] = useState(props.vid);
  let stream;
  let screen;
  let avatarapi = "https://eu.ui-avatars.com/api/?";

  useEffect(() => {
    props.peer.on("stream", (stream) => {
      ref.current.srcObject = stream;
    });
  }, []);

  // useEffect(() => {
  //     if(props.vid == true){
  //         setmuted(true)
  //     }
  //     else if(props.vid == false){
  //         setmuted(false);
  //     }

  // }, [props.vid])

  return <StyledVideo style playsInline autoPlay ref={ref} />;
};

const videoConstraints = {
  height: window.innerHeight / 2,

  width: window.innerWidth / 2,
};

const Roomi = (props) => {
  const [peers, setPeers] = useState([]);

  const [collapsed, setCollapsed] = useState(false);

  const socketRef = useRef();

  const hangref = useRef(null);

  const [lastmsg, setlastmsg] = useState(false);

  const [hangupscr, sethangupscr] = useState(false);

  const forcehang = useRef();

  const [reqscr, setscr] = useState(false); //Req Modal For Screen Share
  const [accscr, setaccscr] = useState(false); //Accepting Screen For Screen Share(Host)
  const [listacc, setlistacc] = useState([]);

  const [acceptedreq, setacceptedreq] = useState("PEND"); // For reqscr Status

  const [hostdisconn, sethostdisconn] = useState(false); //Whether host is disconnected Accidentally

  const history = useHistory();

  const [infospeers, setInfoPeers] = useState([]);
  const infospeersRef = useRef([]);

  var recordedChunks = [];
  const [recording, isRecording] = useState(false);
  const mediaRecorder = useRef();
  const [myName, setMyname] = useState(["You"]);
  const userVideo = useRef();
  const peersRef = useRef([]);
  const mypeer = useRef();
  const host = props.host;
  const [muted, setMuted] = useState(false);

  const meetname = props.title;

  var localmsg = false;

  const [hostended, setHostEnded] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [perc, setperc] = useState();

  const [chatdot, setchatdot] = useState(false);
  const dotref = useRef();

  const [stream, setStream] = useState();
  const [vidtrack, setvidtrack] = useState();

  const [audioMuted, setAudioMuted] = useState(false);
  const [videoMuted, setVideoMuted] = useState(false);
  const roomID = props.roomid;
  const [msg, setmsg] = useState("");
  const [file, setFile] = useState(null);
  const [listmsg, setlistmsg] = useState([]);
  const [messageBox, setMessageBox] = useState(false);

  const [joined, setjoined] = useState(false);
  const [jmodal, setjmodal] = useState(false);

  const [hid, sethid] = useState("");
  const userVideo2 = useRef();

  const [wb, setWB] = useState(false);
  const [userListVisible, setuserListVisible] = useState(false);
  const [modalVisiblity, setmodalVisiblity] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [userVedioVisible, setuserVedioVisible] = useState(false);

  var today = new Date();
  const name = auth().currentUser.displayName;
  var today_hours = today.getHours();
  var today_mins = today.getMinutes();
  var today_secs = today.getSeconds();
  if (today_hours < 10) today_hours = "0" + today_hours;
  if (today_mins < 10) today_mins = "0" + today_mins;
  if (today_secs < 10) today_secs = "0" + today_secs;
  var today_time = today_hours + ":" + today_mins;

  useEffect(() => {
    console.log(host);
    console.log(roomID);

    document.title = "Loading...";
    var murl = "https://project-5backend.onrender.com/";
    var lurl = "http://192.168.181.58:8000/";
    socketRef.current = io.connect(murl);

    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        setStream(stream);
        setvidtrack(stream.getVideoTracks()[0]);
        setjmodal(true);
        userVideo.current.srcObject = stream;
        userVideo2.current.srcObject = stream;

        document.title = meetname;

        const peers = [];
        const infospeers = [];

        socketRef.current.on("user list", (names) => {
          names = names.filter((id) => id !== names[0]);
          setMyname(name);
        });

        socketRef.current.on("mutedall", (payload) => {
          if (!host) {
            alert("Host(" + payload.muter + ") All");
            if (stream) {
              setMuted(true);
              setVideoMuted(true);
              stream.getVideoTracks()[0].enabled = false;
              setAudioMuted(true);
              stream.getAudioTracks()[0].enabled = false;
            }
          }
          for (var i = 0; i < peersRef.current.length; i++) {
            if (peersRef.current[i].peerID !== payload.id) {
              peersRef.current[i].aud = true;
              peersRef.current[i].vid = true;
            }
          }
          setPeers([...peersRef.current]);
        });
        socketRef.current.on("unmutedall", ({ muter }) => {
          if (!host) {
            alert("Host(" + muter + ") Unmuted All");
            setMuted(false);
          }
        });

        socketRef.current.on("host-id", (id) => {
          console.log(id);
          sethid(id);
          console.log("The Host is " + id);
          console.log(hid);
        });
        socketRef.current.on("all users", async (users) => {
          console.log("Users", users);
          infospeersRef.current.push({
            peerID: socketRef.current.id,
            aud: audioMuted,
            vid: videoMuted,
            uname: name,
          });
          infospeers.push({
            peerID: socketRef.current.id,
            aud: audioMuted,
            vid: videoMuted,
            uname: name,
          });

          users.forEach((userID) => {
            const peer = createPeer(userID.id, socketRef.current.id, stream);

            peersRef.current.push({
              peerID: userID.id,
              uname: userID.uname,
              vid: userID.vid,
              aud: userID.aud,
              peer,
            });
            peers.push({
              peerID: userID.id,
              uname: userID.uname,
              vid: userID.vid,
              aud: userID.aud,
              peer,
            });
            infospeers.push({
              peerID: userID.id,
              aud: userID.aud,
              vid: userID.vid,
              uname: userID.uname,
            });
            infospeersRef.current.push({
              peerID: userID.id,
              aud: userID.aud,
              vid: userID.vid,
              uname: userID.uname,
            });
          });

          setInfoPeers(infospeers);
          //    if(host){
          //     setPeers(peers);
          //    }
          //     if(!host){
          //         var hindex = null;
          //     for (var i = 0;  i < peers.length; i++){
          //      const peer = peers[i];
          //     if(peer.peerID === hid){
          //         hindex = i;
          //     }
          //     }
          //     if(hindex !== null){
          //         console.log(peers[hindex]);
          //         setPeers([peers[hindex]]);
          //     }

          //  }
          setPeers(peers);
        });

        socketRef.current.on("audc", (payload) => {
          if (socketRef.current.id !== payload.id) {
            const pee = peersRef.current.findIndex(
              (i) => i.peerID === payload.id
            );

            const pe = infospeersRef.current.findIndex(
              (i) => i.peerID === payload.id
            );
            if (pe && pee) {
              infospeersRef.current[pe].aud = payload.aud;
              peersRef.current[pee].aud = payload.aud;
            }

            setPeers([...peersRef.current]);
            setInfoPeers([...infospeersRef.current]);
          }
        });
        socketRef.current.on("vidc", (payload) => {
          if (socketRef.current.id !== payload.id) {
            const pe = infospeersRef.current.findIndex(
              (i) => i.peerID === payload.id
            );
            const pee = peersRef.current.findIndex(
              (i) => i.peerID === payload.id
            );
            if (pe && pee) {
              infospeersRef.current[pe].vid = payload.vid;
              peersRef.current[pee].vid = payload.vid;
            }

            setInfoPeers([...infospeersRef.current]);
            setPeers([...peersRef.current]);
          }
        });

        socketRef.current.on("user joined", (payload) => {
          // console.log("i")
          console.log(peers.find((p) => p.peerID == socketRef.current.id));
          const peer = addPeer(payload.signal, payload.callerID, stream);

          infospeersRef.current.push({
            peerID: payload.callerID,
            aud: payload.aud,
            vid: payload.vid,
            uname: payload.uname,
          });
          peersRef.current.push({
            peerID: payload.callerID,
            uname: payload.uname,
            vid: payload.vid,
            aud: payload.aud,
            peer,
          });
          const peerObj = {
            peerID: payload.callerID,
            peer,
          };
          console.log(peerObj.peerID);

          //   if(host){
          //     setPeers([...peersRef.current]);
          //   }

          setPeers([...peersRef.current]);
          setInfoPeers([...infospeersRef.current]);

          notify("userjoined");
          console.log(peers);
        });

        socketRef.current.on("receiving returned signal", (payload) => {
          const item = peersRef.current.find((p) => p.peerID === payload.id);
          item.peer.signal(payload.signal);
        });

        console.log(peers);
      });

    socketRef.current.on("createMessage", ({ frmsg, userfrm }) => {
      if (userfrm !== name) {
        setlastmsg(true);
      } else {
        setlastmsg(false);
      }

      dotref.current.click();
      console.log(frmsg + "from" + userfrm, "test");

      setlistmsg((prevstate) => [
        ...prevstate,
        { message: frmsg, user: userfrm },
      ]);
    });
    socketRef.current.on("user-left", (id) => {
      const peerObj = peersRef.current.find((p) => p.peerID === id);
      if (peerObj) {
        peerObj.peer.destroy();
      }
      const peerss = peersRef.current.filter((p) => p.peerID !== id);
      const pers = infospeersRef.current.filter((p) => p.peerID !== id);

      infospeersRef.current = pers;
      peersRef.current = peerss;
      setInfoPeers(pers);

      // if(host){
      // setPeers(peerss);
      // }
      setPeers(peers);
      notify("userleft");
      console.log(peers);
    });
    socketRef.current.on("user leaved", ({ leaved }) => {
      console.log(leaved + " User Disconnected");
    });

    socketRef.current.on("host-closed", (payload) => {
      if (!host) {
        sethostdisconn(payload.disconn);

        setHostEnded(true);

        if (forcehang.current) {
          forcehang.current.click();
        }
      }
    });

    socketRef.current.on("requesting-host", (payload) => {
      const list = {
        name: payload.name,
        id: payload.id,
      };

      setlistacc((i) => [...i, list]);
      setaccscr(true);
    });

    socketRef.current.on("host-accepted", (payload) => {
      setscr(true);
      setacceptedreq("ACCEPTED");
    });
    socketRef.current.on("host-rejected", (payload) => {
      setscr(true);
      setacceptedreq("REJECT");
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  function join() {
    socketRef.current.emit("join room", {
      roomID: roomID,
      aud: audioMuted,
      vid: videoMuted,
      uname: name,
    });

    socketRef.current.emit("add user", name);
    console.log("My ID is" + socketRef.current.id);
    if (host) {
      socketRef.current.emit("host", socketRef.current.id);
    }
    setjoined(true);
    setjmodal(false);
  }

  function createPeer(userToSignal, callerID, stream) {
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream,
    });

    const aud = audioMuted;
    const vid = videoMuted;
    let uname = name;
    peer.on("signal", (signal) => {
      socketRef.current.emit("sending signal", {
        userToSignal,
        aud,
        vid,
        callerID,
        signal,
        uname,
      });
    });
    mypeer.current = peer;

    return peer;
  }

  function addPeer(incomingSignal, callerID, stream) {
    const peer = new Peer({
      initiator: false,
      trickle: false,
      stream,
    });

    mypeer.current = peer;

    peer.on("signal", (signal) => {
      socketRef.current.emit("returning signal", { signal, callerID });
    });

    peer.signal(incomingSignal);

    return peer;
  }

  function getmsg() {
    if (lastmsg && !messageBox) {
      setchatdot(true);
    }
  }
  function req() {
    setacceptedreq("LOAD");
    socketRef.current.emit("request-host", {
      id: socketRef.current.id,
      host: hid,
      name: name,
    });
  }
  function muteall() {
    if (host) {
      socketRef.current.emit("isMutedAll", {
        from: auth().currentUser.displayName,
        id: socketRef.current.id,
      });
      setMuted(true);
    }
  }
  function unmuteall() {
    if (host) {
      socketRef.current.emit("isUnMutedAll", {
        from: auth().currentUser.displayName,
      });
      setMuted(false);
    }
  }

  function shareScreen() {
    if (host) {
      shareScreenn();
    } else {
      setscr(true);
    }
  }

  function acceptthereq(name, id) {
    socketRef.current.emit("host-accepting", { id, name });
    const acc = listacc.filter((i) => i.id !== id);
    if (acc.length == 0) {
      setaccscr(false);
    }
    setlistacc(acc);
    console.log(acc);
  }

  function rejectthereq(name, id) {
    socketRef.current.emit("host-rejecting", { id, name });
    const acc = listacc.filter((i) => i.id !== id);
    if (acc.length == 0) {
      setaccscr(false);
    }
    setlistacc(acc);
  }

  function notify(sound) {
    let url;
    switch (sound) {
      case "userjoined":
        url = new Audio(UserJoined);
        break;
      case "userleft":
        url = new Audio(UserLeft);
        break;
      default:
        break;
    }
    url.play();
  }

  function shareScreenn() {
    navigator.mediaDevices
      .getDisplayMedia({ cursor: true })
      .then((screenStream) => {
        vidtrack.stop();
        if (mypeer.current) {
          mypeer.current.replaceTrack(
            vidtrack,
            screenStream.getVideoTracks()[0],
            stream
          );
        }
        userVideo.current.srcObject = screenStream;
        screenStream.getTracks()[0].onended = () => {
          if (!host) {
            setacceptedreq("PEND");
          }
          if (videoMuted) {
            if (mypeer.current) {
              mypeer.current.replaceTrack(
                screenStream.getVideoTracks()[0],
                vidtrack,
                stream
              );
            }
          } else {
            navigator.mediaDevices
              .getUserMedia({ video: true, audio: true })
              .then((streamm) => {
                if (mypeer.current) {
                  mypeer.current.replaceTrack(
                    vidtrack,
                    streamm.getVideoTracks()[0],
                    stream
                  );
                  setvidtrack(streamm.getVideoTracks()[0]);
                }
                userVideo.current.srcObject = streamm;
              });
          }
        };
      });
  }
  let screenShare;

  if (mypeer.current) {
    screenShare = (
      <span className="iconContainer" onClick={() => shareScreen()}>
        <Tooltip title="Share your screen">
          <Option>
            <span
              style={{
                background: "white",
                borderRadius: "5px",
                padding: "0px 4px",
              }}
            >
              <FontAwesomeIcon
                icon={faArrowUp}
                style={{
                  color: "#108d75",
                  fontSize: "11px",
                }}
              />
            </span>
            {/* <img src={shareMyScreen} alt='shareMyScreen' /> */}
          </Option>
        </Tooltip>
      </span>
    );
  }
  function isMobileDevice() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
  let recordControl;
  if (isMobileDevice()) {
    screenShare = <></>;
    recordControl = <></>;
  }
  function toggleMuteVideo() {
    var lstream = stream;

    if (stream) {
      if (videoMuted) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((streamm) => {
            // stream.addTrack(streamm.getVideoTracks()[0]);

            try {
              lstream.removeTrack(stream.getVideoTracks()[0]);
              setStream(lstream);
            } catch (err) {}

            console.log(stream);
            console.log(streamm.getVideoTracks());

            if (mypeer.current && peers.length > 0) {
              console.log(mypeer.current.streams);
              try {
                mypeer.current.replaceTrack(
                  vidtrack,
                  streamm.getVideoTracks()[0],
                  stream
                );
              } catch (err) {
                mypeer.current.addTrack(streamm.getVideoTracks()[0], stream);

                console.log(err);
              }
            }

            lstream.addTrack(streamm.getVideoTracks()[0]);
            setStream(lstream);
            setvidtrack(streamm.getVideoTracks()[0]);

            userVideo.current.srcObject = streamm;
          });
        if (joined)
          socketRef.current.emit("vid", {
            id: socketRef.current.id,
            vid: false,
          });
      } else {
        // if(mypeer.current) mypeer.current.removeTrack(stream.getVideoTracks()[0], stream);

        stream.getVideoTracks()[0].stop();
        if (joined)
          socketRef.current.emit("vid", {
            id: socketRef.current.id,
            vid: true,
          });
      }
      if (joined) {
        infospeersRef.current[0].vid = !videoMuted;
        setInfoPeers([...infospeersRef.current]);
      }
      setVideoMuted(!videoMuted);
    }
  }
  let videoControl;
  if (stream) {
    if (!host) {
      if (!muted) {
        if (videoMuted) {
          videoControl = (
            <span
              className="iconContainer"
              style={{ background: "#E62020" }}
              onClick={() => toggleMuteVideo()}
            >
              <Tooltip title="Switch on video">
                <Option>
                  {/* <img src={VideoOff} alt='video_muted' /> */}
                  <FontAwesomeIcon icon={faVideoSlash} />
                </Option>
              </Tooltip>
            </span>
          );
        } else {
          videoControl = (
            <span className="iconContainer" onClick={() => toggleMuteVideo()}>
              <Tooltip title="Switch off video">
                <Option>
                  {/* <img src={VideoOn} alt='video' /> */}
                  <FontAwesomeIcon icon={faVideo} />
                </Option>
              </Tooltip>
            </span>
          );
        }
      } else if (muted) {
        if (!host) {
          videoControl = (
            <span
              disabled
              className="iconContainer"
              onClick={() => alert("All Are Muted")}
            >
              <Option>
                <Tooltip title="Switch on video">
                  <img src={VideoOff} alt="video_muted" />
                </Tooltip>
              </Option>
            </span>
          );
        } else if (host) {
        }
      }
      if (videoMuted) {
        videoControl = (
          <span
            className="iconContainer"
            style={{ background: "#E62020" }}
            onClick={() => toggleMuteVideo()}
          >
            <Option>
              <Tooltip title="Switch on video">
                <FontAwesomeIcon icon={faVideoSlash} />
                {/* <img src={VideoOff} alt='video_muted' /> */}
              </Tooltip>
            </Option>
          </span>
        );
      } else {
        videoControl = (
          <span className="iconContainer" onClick={() => toggleMuteVideo()}>
            <Tooltip title="Switch off video">
              <Option>
                <FontAwesomeIcon icon={faVideo} />
                {/* <img src={VideoOn} alt='video' /> */}
              </Option>
            </Tooltip>
          </span>
        );
      }
    } else if (host) {
      if (videoMuted) {
        videoControl = (
          <span
            className="iconContainer"
            style={{ background: "#E62020" }}
            onClick={() => toggleMuteVideo()}
          >
            <Option>
              <Tooltip title="Switch on video">
                <FontAwesomeIcon icon={faVideoSlash} />
                {/* <img src={VideoOff} alt='video_muted' /> */}
              </Tooltip>
            </Option>
          </span>
        );
      } else {
        videoControl = (
          <span className="iconContainer" onClick={() => toggleMuteVideo()}>
            <Tooltip title="Switch off video">
              <Option>
                {/* <img src={VideoOn} alt='video' /> */}
                <FontAwesomeIcon icon={faVideo} />
              </Option>
            </Tooltip>
          </span>
        );
      }
    }
  }
  function removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b);
  }
  function audiomute() {
    if (stream) {
      if (audioMuted) {
        if (joined)
          socketRef.current.emit("aud", {
            id: socketRef.current.id,
            aud: false,
          });
      } else {
        if (joined)
          socketRef.current.emit("aud", {
            id: socketRef.current.id,
            aud: true,
          });
      }
      if (joined) {
        infospeersRef.current[0].aud = !audioMuted;
        setInfoPeers([...infospeersRef.current]);
      }
      setAudioMuted(!audioMuted);
      stream.getAudioTracks()[0].enabled = audioMuted;
    }
  }

  let audioControl;
  if (stream) {
    if (!host) {
      if (!muted) {
        if (audioMuted) {
          audioControl = (
            <span
              className="iconContainer"
              style={{ background: "#E62020 !important" }}
              onClick={() => audiomute()}
            >
              <Tooltip title="Unmute your audio">
                <Option>
                  <FontAwesomeIcon icon={faMicrophoneSlash} />
                  {/* <AudioMutedOutlined /> */}
                </Option>
              </Tooltip>
            </span>
          );
        } else {
          audioControl = (
            <span className="iconContainer" onClick={() => audiomute()}>
              <Tooltip title="Mute your audio">
                <Option>
                  {/* <AudioOutlined /> */}
                  <FontAwesomeIcon icon={faMicrophone} />
                </Option>
              </Tooltip>
            </span>
          );
        }
      } else if (muted) {
        if (!host) {
          audioControl = (
            <span
              disabled
              className="iconContainer"
              style={{ background: "#E62020 !important" }}
              onClick={() => alert("All Are Muted")}
            >
              <Tooltip title="Unmute your audio">
                <Option>
                  <AudioMutedOutlined />
                </Option>
              </Tooltip>
            </span>
          );
        }
      }
    } else if (host) {
      if (audioMuted) {
        audioControl = (
          <span
            className="iconContainer"
            style={{ background: "#E62020" }}
            onClick={() => audiomute()}
          >
            <Tooltip title="Unmute your audio">
              <Option>
                {/* <AudioMutedOutlined /> */}
                <FontAwesomeIcon icon={faMicrophoneSlash} />
              </Option>
            </Tooltip>
          </span>
        );
      } else {
        audioControl = (
          <span className="iconContainer" onClick={() => audiomute()}>
            <Tooltip title="Mute your audio">
              <Option>
                {/* <AudioOutlined /> */}
                <FontAwesomeIcon icon={faMicrophone} />
              </Option>
            </Tooltip>
          </span>
        );
      }
    }
  }

  let screencontrol;
  let hangup;
  if (stream) {
    function startRec() {
      const dispoptions = {
        video: {
          cursor: true,
        },
        audio: true,
      };
      navigator.mediaDevices.getDisplayMedia(dispoptions).then((screen) => {
        var options = { mimeType: "video/webm;codecs=vp9" };
        mediaRecorder.current = new MediaRecorder(screen, options);

        isRecording(true);

        mediaRecorder.current.start();
        console.log(mediaRecorder.current.state);
        mediaRecorder.current.ondataavailable = function (event) {
          recordedChunks.push(event.data);
        };

        screen.getTracks()[0].onended = () => {
          mediaRecorder.current.stop();
          isRecording(false);
        };
        mediaRecorder.current.onstop = function (event) {
          console.log("Video Stopped");
          var blob = new Blob(recordedChunks, {
            type: "video/webm;codecs=vp9",
          });
          recordedChunks = [];
          var url = URL.createObjectURL(blob);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "test.webm";
          a.click();

          window.URL.revokeObjectURL(url);
          console.log(url);
        };
      });
    }

    if (!recording) {
      recordControl = (
        <span className="iconContainer" onClick={() => startRec()}>
          <Option>
            <Tooltip title="Record meeting">
              {/* <img src={recordVideo} alt='recordVideo' /> */}
              <FontAwesomeIcon icon={faRecordVinyl} />
            </Tooltip>
          </Option>
        </span>
      );
    } else {
      recordControl = <></>;
    }

    hangup = (
      <span
        className="iconContainer"
        onClick={() => sethangupscr(true)}
        style={{ background: "#E62020" }}
      >
        <Option>
          <Tooltip title="End meeting">
            {/* <img src={hangUp} alt='hangUp' /> */}
            <FontAwesomeIcon
              icon={faPhone}
              style={{ transform: "rotate(225deg)", marginTop: "6px" }}
            />
          </Tooltip>
        </Option>
      </span>
    );
  }
  function hanguped() {
    if (host) {
      const roomref = db().ref("all-rooms/" + roomID);
      roomref.update({
        status: "PEND",
      });
      socketRef.current.emit("host-leaved", roomID);
    }

    stream.getVideoTracks()[0].stop();
    stream.getAudioTracks()[0].stop();
    var ttoday = new Date();
    var ttoday_hours = ttoday.getHours();
    var ttoday_mins = ttoday.getMinutes();
    var ttoday_secs = ttoday.getSeconds();
    if (ttoday_hours < 10) ttoday_hours = "0" + ttoday_hours;
    if (ttoday_mins < 10) ttoday_mins = "0" + ttoday_mins;
    if (ttoday_secs < 10) ttoday_secs = "0" + ttoday_secs;

    var elapsed_hours = ttoday_hours - today_hours;
    var elapsed_mins = ttoday_mins - today_mins;
    var elapsed_secs = ttoday_secs - today_secs;
    socketRef.current.emit("user leave", { uname: name });

    var elapsed_time = elapsed_hours + ":" + elapsed_mins + ":" + elapsed_secs;
    history.push({
      pathname: "/CallEnded",
      state: {
        title: meetname,
        duration: elapsed_time,
        hostended: hostended,
        host: host,
        hdiscon: hostdisconn,
        roomid: roomID,
      },
    });
  }

  const handleKeyPress = () => {
    if (msg === "") {
      return message.error({
        content: "Type Something",
        duration: [2],
      });
    }
    socketRef.current.emit("message", { message: msg, from: name });
    console.log("press enter here!");
    console.log(msg);
    setmsg("");
  };

  function handleFileChange(event) {
    setFile(event.target.files[0]);
  }

  function handleInputChange(event) {
    setmsg(event.target.value);
  }

  function sendFile() {
    setUploading(true);
    const storef = storage()
      .ref("room/" + roomID + "/" + file.name)
      .put(file);

    storef.on(
      "state_changed",
      (snapshot) => {
        const perc = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setperc(perc);
      },
      (err) => {
        console.log(err);
      },
      () => {
        setFile(null);

        setperc();
        storage()
          .ref("room/" + roomID + "/" + file.name)
          .getDownloadURL()
          .then((url) => {
            console.log(url);
            socketRef.current.emit("message", { message: url, from: name });
          });
        setUploading(false);
      }
    );
  }
  function toggleWhiteboard() {
    setWB(!wb);
    setuserListVisible(false);
    setMessageBox(false);
  }
  function toggleMessageBox() {
    localmsg = true;
    setuserListVisible(false);
    setMessageBox(true);
    setchatdot(false);
    setWB(false);
    setCollapsed(true);
  }
  function toggleUsersList() {
    setMessageBox(false);
    setuserListVisible(true);
    setWB(false);
    setCollapsed(true);
  }

  const closeSidebar = () => {
    setCollapsed(false);
    localmsg = false;
    setMessageBox(false);
    setuserListVisible(false);

    setPosition({ x: 0, y: 0 });
  };

  const handleDrag = (e, data) => {
    setPosition({ x: data.x, y: data.y });
  };

  const menu = (
    <Menu className="menu-div">
      <Menu.Item key="0">
        <MenuDetail onClick={() => shareScreen()}>Share screen</MenuDetail>
      </Menu.Item>
      <Menu.Item key="1">
        <Badge dot={chatdot}>
          <MenuDetail onClick={() => toggleMessageBox()}>Chat</MenuDetail>
        </Badge>
      </Menu.Item>
      <Menu.Item key="2">
        <MenuDetail onClick={() => toggleWhiteboard()}>WhiteBoard</MenuDetail>
      </Menu.Item>
      <Menu.Item key="3">
        <MenuDetail onClick={() => setmodalVisiblity(true)}>
          Meeting details
        </MenuDetail>
      </Menu.Item>
    </Menu>
  );

  return (
    <Container>
      <Content style={{ position: "relative" }}>
        <Draggable position={position} onDrag={handleDrag}>
          <DraggableDiv>
            <StyledVideo
              muted
              ref={userVideo}
              autoPlay
              playsInline
              style={{ visibility: userVedioVisible ? "visible" : "hidden" }}
            />
            {joined && userVedioVisible && (
              <>
                <UserName>{myName}</UserName>
                <FontAwesomeIcon
                  icon={faTimes}
                  className="fa-icon"
                  onClick={() => setuserVedioVisible(false)}
                />
              </>
            )}
            {!userVedioVisible && (
              <UserInitLogoDiv>
                <p onClick={() => setuserVedioVisible(true)}>
                  {myName[0].charAt(0)}
                </p>
              </UserInitLogoDiv>
            )}
          </DraggableDiv>
        </Draggable>
        <ScreenSection>
          <VedioContainer>
            {
              <>
                {peers &&
                  peers.map((peer) => {
                    return (
                      <AllUsersVideo
                        style={{
                          flexBasis: `${
                            peers.length < 5 ? 90 / peers.length : 24
                          }%`,
                        }}
                      >
                        <Video
                          key={peer.peerID}
                          name={peer.uname}
                          vid={peer.vid}
                          peer={peer.peer}
                          style={{ width: "90%", borderRadius: "5px" }}
                        />

                        <UserName>{peer.uname}</UserName>
                      </AllUsersVideo>
                    );
                  })}
              </>
            }
          </VedioContainer>
        </ScreenSection>
        <CallControlWrapper>
          {
            <OptionContainer>
              {audioControl}
              {videoControl}
              {recordControl}
              {hangup}
              <Tooltip title="Participants list">
                <span
                  className="iconContainer"
                  onClick={() => toggleUsersList()}
                >
                  <Option>
                    <FontAwesomeIcon icon={faUsers} />
                    {/* <img src={usersImg} alt='usersImg' /> */}
                  </Option>
                </span>
              </Tooltip>
              <span className="iconContainer">
                <Option>
                  <Badge dot={chatdot}>
                    <Dropdown
                      overlay={menu}
                      trigger={["click"]}
                      className="menu-div"
                    >
                      <FontAwesomeIcon icon={faEllipsisH} />
                    </Dropdown>
                  </Badge>
                </Option>
              </span>
              {/* {screenShare}
                        {screencontrol} */}
              {/* <Tooltip title="WhiteBoard">
                            <span className='iconContainer' onClick={() => toggleWhiteboard()}>
                                <Option >
                                    <FontAwesomeIcon icon={faStopCircle} />
                                </Option>
                            </span>
                        </Tooltip> */}
              {/* <Tooltip title="Send message">
                            <span className='iconContainer' onClick={() => toggleMessageBox()}>
                                <Option >
                                    <FontAwesomeIcon icon={faCommentDots} />
                                </Option>
                            </span>
                        </Tooltip> */}
            </OptionContainer>
          }
        </CallControlWrapper>
      </Content>

      <Sidebar
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ display: collapsed ? "block" : "none" }}
      >
        <div className="close-container">
          <FontAwesomeIcon
            icon={faTimes}
            className="fa-icon"
            onClick={closeSidebar}
          />
        </div>
        {messageBox && (
          <>
            <MessageBox>
              <p className="title">Chat here</p>
              <div class="chat_box">
                <div class="body">
                  {listmsg.length > 0 &&
                    listmsg.map((msg) => (
                      <>
                        {msg.user !== myName ? (
                          <div class="incoming">
                            <div class="text">
                              <div className="profile-container">
                                <Avatar icon={<UserOutlined />} />
                                <p className="profile-user-name">{msg.user}</p>
                              </div>
                              <p className="msg">{msg.message}</p>
                            </div>
                          </div>
                        ) : (
                          <div class="outgoing">
                            <div class="text">
                              <div className="profile-container">
                                <Avatar icon={<UserOutlined />} />
                                <p className="profile-user-name">You</p>
                              </div>
                              <p className="msg">{msg.message}</p>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                </div>
              </div>
            </MessageBox>
            <MessageButtonContainer>
              <div className="progress-div">
                {uploading && (
                  <div style={{ width: "95%" }}>
                    {" "}
                    <Progress
                      percent={perc}
                      // percent={25}
                      showInfo={false}
                    />{" "}
                  </div>
                )}
              </div>
              <div className="msg-input-contrl-div">
                <div className="msg-container">
                  <input
                    type="text"
                    value={msg}
                    onChange={handleInputChange}
                    class="msg"
                    placeholder="Type a message..."
                    id="msg"
                  />
                  <FontAwesomeIcon
                    onClick={() => handleKeyPress()}
                    icon={faPaperPlane}
                  />
                </div>
                <div className="buttons-div">
                  {file === null && (
                    <label>
                      <FontAwesomeIcon icon={faPaperclip} />
                      <input
                        type="file"
                        size="60"
                        id="file-input"
                        onChange={handleFileChange}
                      />
                    </label>
                  )}
                  {file !== null && (
                    <div className="icons-div">
                      <FontAwesomeIcon
                        className="fa-icon"
                        icon={faCloudUploadAlt}
                        onClick={() => sendFile()}
                      />
                      <FontAwesomeIcon
                        className="fa-icon"
                        icon={faTimes}
                        onClick={() => setFile(null)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </MessageButtonContainer>
          </>
        )}

        {userListVisible && (
          <div>
            <p className="title">Participants ({infospeers.length})</p>
            {infospeers &&
              infospeers.map((peer, key) => {
                return (
                  <div className="participant-list">
                    <p>
                      {peer.uname} {peer.peerID === hid ? "(Host)" : ""}
                      {peer.peerID === socketRef.current.id ? "(Me)" : ""}
                      {key === 0 && host ? "(Host)" : ""}
                    </p>
                    <div>
                      <span>
                        {peer.aud ? (
                          <FontAwesomeIcon icon={faMicrophoneSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faMicrophone} />
                        )}
                      </span>
                      <span>
                        {peer.vid ? (
                          <FontAwesomeIcon icon={faVideoSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faVideo} />
                        )}
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </Sidebar>
      {host
        ? accscr && (
            <ScreenAcc
              visible={accscr}
              onCancel={() => {
                if (listacc == null) {
                  setaccscr(false);
                } else {
                  alert("Accept or Reject");
                }
              }}
            >
              {listacc &&
                listacc.map((i) => {
                  return (
                    <div key={i.id}>
                      <text>{i.name} is Requesting ShareScreen</text>
                      <Button onClick={() => acceptthereq(i.name, i.id)}>
                        Accept
                      </Button>
                      <Button onClick={() => rejectthereq(i.name, i.id)}>
                        Reject
                      </Button>
                    </div>
                  );
                })}
            </ScreenAcc>
          )
        : reqscr && (
            <ScreenReq visiblity={reqscr} onCancel={() => setscr(false)}>
              {acceptedreq === "PEND" ? (
                <Button onClick={() => req()}>Request</Button>
              ) : acceptedreq === "ACCEPTED" ? (
                <Button onClick={() => shareScreenn()}>
                  Host Accepted Share
                </Button>
              ) : acceptedreq === "REJECT" ? (
                <text>
                  Host is Rejected Your Request{" "}
                  <Button
                    onClick={() => {
                      setacceptedreq("PEND");
                    }}
                  >
                    Re Request
                  </Button>
                </text>
              ) : (
                <Loader />
              )}
            </ScreenReq>
          )}
      {hangupscr && (
        <Modal
          closable={false}
          cancelButtonProps={{ style: { display: "none" } }}
          footer={[
            <Button danger key="Hangup" onClick={() => hanguped()}>
              HangUp
            </Button>,
            <Button key="Cancel" onClick={() => sethangupscr(false)}>
              Cancel
            </Button>,
          ]}
          visible={hangupscr}
        >
          <div>Are You Sure Want To Hangup The Meeting</div>
        </Modal>
      )}
      {jmodal && (
        <Modal visible={jmodal} closable={false} footer={null} keyboard={false}>
          <Button onClick={() => join()}>Join</Button>
          {audioControl}
          {videoControl}
          <StyledVideo muted autoPlay playsInline ref={userVideo2} />
        </Modal>
      )}
      <button
        ref={forcehang}
        onClick={() => hanguped()}
        style={{ visiblity: "hidden", display: "none" }}
      ></button>
      <button
        ref={dotref}
        onClick={() => getmsg()}
        style={{ visiblity: "hidden", display: "none" }}
      ></button>
    </Container>
  );
};

export default Roomi;
